export default __webpack_public_path__ + "static/4ringtubes-98188642f955a90aa324d26b472929a4.png";